<script setup>
import { computed, useAttrs } from 'vue'
import { getImage } from '@helpers/utils'

const props = defineProps({
  src: { type: [String, Object], required: true },
  srcset: { type: String, default: null },
  width: { type: [String, Number], default: null },
  alt: { type: String, default: '' },
  height: { type: [String, Number], default: null },
  format: { type: String, default: null },
  fit: { type: String, default: null },
  position: { type: String, default: null },
  quality: { type: [String, Number], default: '90' },
  loading: { type: String, default: 'lazy' },
  densities: { type: Array, default: () => [] },
})

const restAttrs = useAttrs()

const image = computed(() => getImage({
  src: props.src,
  width: props.width,
  height: props.height,
  format: props.format,
  fit: props.fit,
  position: props.position,
  quality: props.quality,
  densities: props.densities,
}))
</script>

<template>
  <img
      :src="image.src"
      :srcset="image.srcset"
      :alt="alt"
      :width="image.width"
      :height="image.height"
      :loading="loading"
      v-bind="restAttrs"
  />
</template>
